import { gql } from '@apollo/client/core';

export const CONSTANT_QUERY_LIST = gql`
  query Constants {
    meter_types {
      energy_type
      id
      name
      step_seconds
    }
  }
`;
